import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { VaccinationTypesEnum } from 'src/app/locums/locums-constants';
import { FacilityProfileDetails } from 'src/app/locums/models/facility-profile-details.model';
import { PatientAgeGroup } from 'src/app/locums/models/patient-age-group.interface';
import { UnitDetails } from 'src/app/locums/models/unit-details.model';
import { UnitPracticeSetting } from 'src/app/locums/models/unit-practice-setting.interface';
import { VaccinationRequirements } from 'src/app/locums/models/vaccination-requirements';
import { LocumsJobService } from 'src/app/locums/services/locums-job.service';
import { Store } from '@ngrx/store';
import { selectJobUnitDetails } from 'src/app/root-store/locums-store/selectors/job.selector';
import { Observable } from 'rxjs';
import { LocumsUtility } from 'src/app/locums/locums-utility';

@UntilDestroy()
@Component({
    selector: 'nova-locums-recruiter-work',
    templateUrl: './locums-recruiter-work.component.html',
    styleUrls: ['./locums-recruiter-work.component.scss']
})
export class LocumsRecruiterWorkComponent implements OnInit {
    @Input() jobId: number;
    unitDetails: UnitDetails;
    facilityProfileDetails: FacilityProfileDetails;
    vaccinationRequirements: VaccinationRequirements[];
    practiceSettingsText: string;
    patientAgeGroupsText: string;
    unitDetails$: Observable<UnitDetails>;
    getVaccinationType = LocumsUtility.getVaccinationType;

    constructor(private readonly locumsJobService: LocumsJobService, private readonly store: Store) {}

    ngOnInit(): void {
        this.getUnitDetails();
        this.getPracticeSettings(this.jobId);
        this.getFacilityProfileDetails(this.jobId);
        this.getVaccinationRequirements(this.jobId);
        this.getPatientAgeGroups(this.jobId);
    }

    getUnitDetails(): void {
        this.unitDetails$ = this.store.select(selectJobUnitDetails);
    }

    getFacilityProfileDetails(jobId: number): void {
        this.locumsJobService
            .getFacilityProfileDetails(jobId)
            .pipe(untilDestroyed(this))
            .subscribe((facilityProfileDetails: FacilityProfileDetails) => {
                this.facilityProfileDetails = facilityProfileDetails;
            });
    }

    getVaccinationRequirements(jobId: number): void {
        const vaccinationTypes = [VaccinationTypesEnum.Covid19, VaccinationTypesEnum.Flu];
        this.locumsJobService
            .getVaccinationRequirements(jobId)
            .pipe(untilDestroyed(this))
            .subscribe((vaccinationRequirements: VaccinationRequirements[]) => {
                this.vaccinationRequirements = vaccinationRequirements.filter((x) =>
                    vaccinationTypes.includes(x.vaccinationTypeId)
                );
            });
    }

    getPatientAgeGroups(jobId: number): void {
        this.locumsJobService
            .getUnitPatientAgeGroups(jobId)
            .pipe(untilDestroyed(this))
            .subscribe((patientAgeGroups: PatientAgeGroup[]) => {
                this.patientAgeGroupsText = patientAgeGroups?.map((x) => x.title).join(', ');
            });
    }

    getPracticeSettings(jobId: number): void {
        this.locumsJobService
            .getUnitPracticeSettings(jobId)
            .pipe(untilDestroyed(this))
            .subscribe((practiceSettings: UnitPracticeSetting[]) => {
                this.practiceSettingsText = practiceSettings
                    ?.filter((x) => x.unitType !== 'Unknown')
                    ?.map((x) => x.unitType)
                    .join(', ');
            });
    }
}
